import founderPhoto from '../assets/images/about/founder.jpg';
import frustrationArtwork from '../assets/images/about/frustration-reference.jpg';
import { ArrowRight } from 'lucide-react';
import europeVision from '../assets/images/about/europe-vision.jpg';
import build2Small from '../assets/images/about/project-ecosystem-600.jpg';
import build2Large from '../assets/images/about/project-ecosystem-1200.jpg';
import build1Small from '../assets/images/about/quality-control-600.jpg';
import build1Large from '../assets/images/about/quality-control-1200.jpg';
import build0Small from '../assets/images/about/curated-marketplace-600.jpg';
import build0Large from '../assets/images/about/curated-marketplace-1200.jpg';
import { useI18n } from '../i18n/LanguageContext';






const About=()=>{
  const { t } = useI18n();

    return (
<div className="about2">

  {/* ===== HERO ===== */}
  <section className="about2Hero">
    <div className="about2HeroContent">
      <h1>
        {t("TronicsBase is not just a store.")}</h1>
      <h2>
        {t("It’s infrastructure for builders.")}</h2>
      <p>
        {t("We’re building a structured ecosystem where components, projects and sourcing work together.")}</p>
    </div>
  </section>


  {/* ===== STORY SPLIT SECTION ===== */}
  <section className="about2Split frustrationSection">

    <div className="splitText">
      <h3>{t("The Frustration")}</h3>
      <p>
        {t("Electronics projects shouldn’t feel like supply chain management. Yet builders juggle unreliable suppliers, long shipping delays, inconsistent quality and scattered tutorials.")}</p>
    </div>

    <ol className="frustrationCards">
      {[
        { title: 'Fragmented buying experience', position: 'buying' },
        { title: 'Unpredictable quality', position: 'quality' },
        { title: 'No structured ecosystem', position: 'ecosystem' },
      ].map(({ title, position }, index) => <li className="frustrationCard" key={position}>
        <div className="frustrationCardHeading"><span>0{index + 1}</span><h4>{t(title)}</h4></div>
        <div className={`frustrationArt ${position}`} aria-hidden="true"><img src={frustrationArtwork} alt="" loading="lazy"/></div>
        {index < 2 && <span className="frustrationArrow" aria-hidden="true"><ArrowRight size={20}/></span>}
      </li>)}
    </ol>

  </section>


  {/* ===== WHAT WE BUILT ===== */}
  <section className="about2Build">

    <h2>{t("What We’re Building")}</h2>

    <div className="buildGrid">

      <div className="buildCard">
        <img className="buildIllustration" src={build0Large} srcSet={`${build0Small} 600w, ${build0Large} 1200w`} sizes="(max-width: 760px) 92vw, 360px" width={1200} height={675} alt={t("Curated Marketplace")} loading="lazy"/>
        <div className="buildCardCopy"><h3>{t("Curated Marketplace")}</h3>
        <p>
          {t("Focused component selection built around real projects.")}</p></div>
      </div>

      <div className="buildCard">
        <img className="buildIllustration" src={build1Large} srcSet={`${build1Small} 600w, ${build1Large} 1200w`} sizes="(max-width: 760px) 92vw, 360px" width={1200} height={675} alt={t("Quality Control Layer")} loading="lazy"/>
        <div className="buildCardCopy"><h3>{t("Quality Control Layer")}</h3>
        <p>
          {t("Selected sourcing and inspection before European delivery.")}</p></div>
      </div>

      <div className="buildCard">
        <img className="buildIllustration" src={build2Large} srcSet={`${build2Small} 600w, ${build2Large} 1200w`} sizes="(max-width: 760px) 92vw, 360px" width={1200} height={675} alt={t("Project Ecosystem")} loading="lazy"/>
        <div className="buildCardCopy"><h3>{t("Project Ecosystem")}</h3>
        <p>
          {t("Builders share structured projects and earn rewards.")}</p></div>
      </div>

    </div>

  </section>


  {/* ===== FOUNDER BLOCK ===== */}
  <section className="about2Founder">

    <div className="founderCard">
      <img className="founderPhoto" src={founderPhoto} alt={t("TronicsBase founder")} width={800} height={1200} loading="lazy"/>
      <div className="founderCopy">
      <h3>{t("Founder’s Perspective")}</h3>
      <p>
        {t("TronicsBase started from building projects myself. I wanted an environment where sourcing, logistics, and project structure were unified — not chaotic.")}</p>
      <p>
        {t("This platform is engineered the same way good hardware is: structured, reliable, and scalable.")}</p>
      <div className="founderSignatureBlock">
        <strong>Luis HR</strong>
        <span className="founderRole">{t("TronicsBase founder")}</span>
      </div>
      </div>
    </div>

  </section>


  {/* ===== VISION ===== */}
  <section className="about2Vision">
    <h2>
      {t("The goal is simple:")}</h2>
    <p>
      {t("Become the European reference ecosystem for DIY electronics.")}</p>
    <img className="visionIllustration" src={europeVision} alt="" width={1200} height={675} loading="lazy"/>
  </section>

</div>
    )
}

export default About;